define('shoptheme/components/customer/account/edit',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	_,
	Component,
	BEM
) {
	var BLOCK = 'customer-account-edit';

	return Component.create({
		blocks: null,

		$init: function() {
			this.blocks = BEM.block(BLOCK);
			this.blocks.each(function() {
				var block = BEM.block(this),
					form = block.getElements('form'),
					containerChangePassword = block.getElements('container-change-password'),
					containerCurrentPassword = block.getElements('container-current-password'),
					inputChangePassword = block.getElements('input-change-password'),
					inputCurrentPassword = block.getElements('input-current-password'),
					inputNewPassword = block.getElements('input-new-password'),
					inputNewPasswordConfirm = block.getElements('input-new-password-confirm'),
					inputEmail = block.getElements('input-email'),
					originalValues = _.map($.prop(form.get(0), 'elements'), function(node) { return {node: node, value: $(node).val()}; });

				function getOriginalValue(node) {
					return _.get(_.find(originalValues, {node: node}), 'value');
				}

				function showHideContainerCurrentPassword() {
					var show = inputChangePassword.is(':checked');
					show |= inputEmail.val() !== getOriginalValue(inputEmail.get(0));

					containerCurrentPassword[show ? 'show' : 'hide']();
					inputCurrentPassword[show ? 'addClass' : 'removeClass']('required-entry');
				}

				function showHideContainerChangePassword() {
					var show = inputChangePassword.is(':checked');
					containerChangePassword[show ? 'show' : 'hide']();
					inputNewPassword[show ? 'addClass' : 'removeClass']('required-entry');
					inputNewPasswordConfirm[show ? 'addClass' : 'removeClass']('required-entry');
				}

				inputChangePassword.on('change', showHideContainerChangePassword);
				inputChangePassword.on('change', showHideContainerCurrentPassword);
				inputEmail.on('keyup', showHideContainerCurrentPassword);

				showHideContainerCurrentPassword();
				showHideContainerChangePassword();
			});
		}
	});
});
